export const navItems = [
  { label: "首页", href: "#top" },
  { label: "热点主线", href: "#featured" },
  { label: "完整时间线", href: "#timeline" },
  { label: "证据材料", href: "#evidence" },
  { label: "知情人透露", href: "#insider" },
  { label: "线索提交", href: "#submit" },
];

export const tickerItems = [
  { time: "12:40", text: "内部截图一组（共 9 张）已归档入时间线第 15 天节点" },
  { time: "11:05", text: "录音证据新增 2 段节选，已做去重与时间戳校对" },
  { time: "09:32", text: "原帖备份索引更新至 v2.4，完整时间线新增 3 个关键节点" },
  { time: "昨日", text: "知情人第三次补充说明已收录，涉及前后说法差异" },
  { time: "昨日", text: "某联名合作风波主线材料整理完毕，进入对比阶段" },
];

export const quickEntries = [
  {
    icon: "ri-chat-history-line",
    title: "聊天记录",
    count: "142 组",
    desc: "按对话方与时间归类",
    href: "#evidence",
  },
  {
    icon: "ri-mic-line",
    title: "录音证据",
    count: "68 段",
    desc: "含时长与关键句标注",
    href: "#evidence",
  },
  {
    icon: "ri-image-line",
    title: "内部截图",
    count: "326 张",
    desc: "已去重并校对时间戳",
    href: "#evidence",
  },
  {
    icon: "ri-time-line",
    title: "完整时间线",
    count: "5 条主线",
    desc: "从起点到最新进展",
    href: "#timeline",
  },
];

export const heroStats = [
  { value: "536", unit: "份", label: "收录材料" },
  { value: "128", unit: "个", label: "关键节点" },
  { value: "90", unit: "天", label: "时间线跨度" },
  { value: "v2.4", unit: "", label: "当前版本" },
];

export const featureCards = [
  {
    id: "f-01",
    tag: "热点主线",
    title: "某品牌联名合作突然叫停，前后说法相差三步",
    excerpt:
      "从预热海报到下架公告只隔了 36 小时。把公开声明、预告物料与内部沟通记录并排放在一起，事件的转向节点其实早有伏笔。",
    time: "2 小时前更新",
    heat: "8.6万 人看过",
    read: "9 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20style%20abstract%20collage%20of%20red%20and%20gold%20paper%20fragments%20on%20warm%20cream%20background%2C%20soft%20studio%20light%2C%20clean%20minimal%20product%20photography%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=900&height=680&seq=hle-feature-01&orientation=landscape",
  },
  {
    id: "f-02",
    tag: "录音证据",
    title: "综艺录制现场音频节选流出，逐句拆解后露出三段剪辑痕迹",
    excerpt:
      "把公开流传的版本与完整时长的对比后发现，开头约十几秒被剪掉，导致语境发生了变化，这也是争议出现的直接原因。",
    time: "5 小时前更新",
    heat: "6.2万 人看过",
    read: "11 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Studio%20audio%20waveform%20visual%20concept%20on%20warm%20beige%20background%20with%20deep%20red%20accents%2C%20minimal%20editorial%20still%20life%2C%20soft%20diffused%20lighting%2C%20clean%20composition%2C%20high%20detail&width=900&height=680&seq=hle-feature-02&orientation=landscape",
  },
  {
    id: "f-03",
    tag: "内部截图",
    title: "内部群聊截图集中曝光，时间戳成为判断真伪的关键线索",
    excerpt:
      "截图的先后顺序、消息气泡方向与系统时间三者必须相互印证。我们整理了全部 326 张截图，标注出 4 处对不上的地方。",
    time: "昨天更新",
    heat: "11.4万 人看过",
    read: "14 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20layered%20paper%20cards%20with%20soft%20shadows%20on%20warm%20cream%20surface%2C%20red%20and%20gold%20foil%20edges%2C%20minimal%20editorial%20photography%2C%20soft%20natural%20light%2C%20high%20detail&width=900&height=680&seq=hle-feature-03&orientation=landscape",
  },
  {
    id: "f-04",
    tag: "完整时间线",
    title: "当事人回应与前后说法对比，争议点集中在两个时间段",
    excerpt:
      "把三次公开发言按时间排列，会发现关键表述在一次采访后出现转向。完整时间线已更新到第 90 天的最新归档。",
    time: "2 天前更新",
    heat: "9.1万 人看过",
    read: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20timeline%20concept%20visual%20with%20warm%20amber%20dots%20connected%20by%20thin%20lines%20on%20cream%20background%2C%20editorial%20graphic%20style%2C%20soft%20lighting%2C%20clean%20harmonious%20composition%2C%20high%20detail&width=900&height=680&seq=hle-feature-04&orientation=landscape",
  },
];

export const timelineNodes = [
  {
    day: "第 1 天",
    title: "事件起点",
    desc: "一条匿名讨论帖出现在公开社区，内容为一组不完整的对话截图，未标明来源与实际时间。",
    tag: "起点",
  },
  {
    day: "第 3 天",
    title: "首波材料出现",
    desc: "多个账号开始转发所谓「原帖备份」，材料数量快速增加，但版本之间存在明显差异。",
    tag: "扩散",
  },
  {
    day: "第 7 天",
    title: "关键录音流出",
    desc: "一段约 3 分钟的音频节选被公开，成为后续讨论的主要依据，完整时长存在争议。",
    tag: "关键",
  },
  {
    day: "第 15 天",
    title: "内部截图集中曝光",
    desc: "一组共 9 张内部沟通截图集中出现，时间戳与对话方向成为判断真伪的核心线索。",
    tag: "关键",
  },
  {
    day: "第 30 天",
    title: "知情人补充说明",
    desc: "有自称知情者的人士陆续补充三次说明，指出早期版本与现流传版本存在差异。",
    tag: "补充",
  },
  {
    day: "第 45 天",
    title: "当事人公开回应",
    desc: "相关方发布书面回应，对部分材料作出说明，但仍有两点未被正面解释。",
    tag: "回应",
  },
  {
    day: "第 90 天",
    title: "最新进展归档",
    desc: "新增材料趋于平稳，本页将全部节点按时间顺序归档，并标注每份材料的来源与核对结果。",
    tag: "归档",
  },
];

export const evidenceCards = [
  {
    icon: "ri-chat-history-line",
    title: "聊天记录合集",
    meta: "142 组 · 已按对话方归类",
    desc: "包含主要对话链路的完整截图，标注出 6 处上下文缺失的位置，方便逐句对照。",
    action: "查看合集",
    updated: "更新至 09/10",
  },
  {
    icon: "ri-mic-line",
    title: "录音证据",
    meta: "68 段 · 总时长约 12 小时 36 分",
    desc: "按场景与时间分段整理，关键句已单独标注时间点，并注明是否存在剪辑痕迹。",
    action: "查看音频",
    updated: "更新至 09/09",
  },
  {
    icon: "ri-image-line",
    title: "内部截图",
    meta: "326 张 · 已去重校对",
    desc: "全部截图按时间戳排序，标注出 4 处时间对不上的位置，并给出交叉验证结论。",
    action: "查看截图",
    updated: "更新至 09/08",
  },
];

export const insiderQuotes = [
  {
    quote: "其实最早流传的版本和现在这个不太一样，中间明显被人改过，语句顺序都换了。",
    source: "知情人 A · 补充说明",
    time: "第 30 天",
  },
  {
    quote: "那段录音不是完整版，片头还有十几秒被剪掉了，剪掉之后语气听起来就变了。",
    source: "知情人 B · 补充说明",
    time: "第 32 天",
  },
  {
    quote: "截图里的时间戳和系统时间对不上，同一个会话不可能出现这样的间隔，应该有拼接。",
    source: "知情人 C · 补充说明",
    time: "第 36 天",
  },
];

export const materialRatio = [
  { label: "聊天记录", value: 46 },
  { label: "内部截图", value: 31 },
  { label: "录音证据", value: 15 },
  { label: "其他材料", value: 8 },
];

export const rankingList = [
  {
    rank: 1,
    title: "联名风波完整梳理：从预热海报到下架公告",
    tag: "热点主线",
    heat: "8.6万",
  },
  {
    rank: 2,
    title: "录音逐句拆解：被剪掉的十几秒说了什么",
    tag: "录音证据",
    heat: "6.2万",
  },
  {
    rank: 3,
    title: "326 张截图时间线对照，找出 4 处对不上",
    tag: "内部截图",
    heat: "11.4万",
  },
  {
    rank: 4,
    title: "知情人三次补充说明前后的关键差异",
    tag: "知情人",
    heat: "5.7万",
  },
  {
    rank: 5,
    title: "回应全文与争议点对照，两点未被正面解释",
    tag: "完整时间线",
    heat: "9.1万",
  },
];

export const footerLinks = [
  {
    title: "内容入口",
    links: ["热点主线", "完整时间线", "证据材料", "知情人透露"],
  },
  {
    title: "关于本站",
    links: ["站点说明", "材料归档规则", "核对标准", "联系编辑"],
  },
  {
    title: "合规与立场",
    links: ["免责声明", "反对网络暴力", "隐私保护说明", "线索处理原则"],
  },
];

export const disclaimerText =
  "本站为内容演示站点，页面中所有人物、事件、材料、时间线均为虚构示例，不对应任何真实个人、单位或事件。本站反对网络暴力、人肉搜索与未经授权传播他人隐私，倡导理性讨论、文明浏览。";